export function timeout(ms, promise) {
  return new Promise(function(resolve, reject) {
    setTimeout(function() {
      reject(new Error("timeout"))
    }, ms)
    promise.then(resolve, reject)
  });
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function retry(ms, retries, func) {
  for (let i = 0; i < retries; i++) {
    try {
      return await timeout(ms, func());
    } catch(e) {
      await sleep(ms);
    }
  }
  throw new Error("max retries reached");
}

export function convertTimestampToDate(timestamp, addYear = true, addDay = true) {
  var date = new Date(timestamp * 1000);
  var month = "0" + (date.getMonth() + 1);
  var result = month.substr(-2);
  if (addYear) {
    var year = date.getYear() + 1900;
    result = year + '/' + result;
  }
  if (addDay) {
    var day = "0" + date.getDate();
    result  = result + '/' + day.substr(-2)
  }
  return result;
}

export function convertTimestampToTime(timestamp, addSeconds = true) {
  timestamp = parseFloat(timestamp) * 1000;

  var date = new Date(timestamp);
  var hours = date.getHours();
  var minutes = "0" + date.getMinutes();
  var result = hours + ':' + minutes.substr(-2);
  if (addSeconds) {
    var seconds = "0" + date.getSeconds();
    result += ':' + seconds.substr(-2);
  }
  return result;
}

export function convertSecondsToDuration(seconds, addSeconds = true) {
  var sec_num = parseInt(seconds, 10);
  var hours   = Math.floor(sec_num / 3600);
  if (hours   < 10) {hours   = "0"+hours;}
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  if (minutes < 10) {minutes = "0"+minutes;}
  var result = hours+':'+minutes;
  if (addSeconds) {
    var sec = sec_num - (hours * 3600) - (minutes * 60);
    if (sec < 10) {sec = "0"+sec;}
    result += ':'+sec;
  }
  return result
}

export function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

//See: https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
export const pSBC = (p,c0,c1,l) => {
    let r,g,b,P,f,t,h,i = parseInt,m=Math.round,a=typeof(c1)=="string";
    if(typeof(p)!=="number"||p<-1||p>1||typeof(c0)!=="string"||(c0.charAt(0)!=='r'&&c0.charAt(0)!=='#')||(c1&&!a))
      return null;
    const pSBCr = (d) =>{
        let n=d.length,x={};
        if(n>9) {
            d=d.split(",");
            [r,g,b,a]=d;
            n=d.length;
            if(n<3||n>4)return null;
            x.r=i(r[3]==="a"?r.slice(5):r.slice(4));
            x.g=i(g);
            x.b=i(b);
            x.a=a?parseFloat(a):-1;
        } else {
            if(n===8||n===6||n<4)return null;
            if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
            d=i(d.slice(1),16);
            if(n===9||n===5){
                x.r=d>>24&255;
                x.g=d>>16&255;
                x.b=d>>8&255;
                x.a=m((d&255)/0.255)/1000;
            }
            else {
                x.r=d>>16;
                x.g=d>>8&255;
                x.b=d&255;
                x.a=-1
            }
        }
        return x};
    h=c0.length>9;
    h=a?c1.length>9?true:c1==="c"?!h:false:h;
    f=pSBCr(c0);
    P=p<0;
    t=c1&&c1!=="c"?pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1};
    p=P?p*-1:p;
    P=1-p;
    if(!f||!t)return null;
    if(l){
        r=m(P*f.r+p*t.r);
        g=m(P*f.g+p*t.g);
        b=m(P*f.b+p*t.b);
    }
    else {
        r=m((P*f.r**2+p*t.r**2)**0.5);
        g=m((P*f.g**2+p*t.g**2)**0.5);
        b=m((P*f.b**2+p*t.b**2)**0.5);
    }
    a=f.a;
    t=t.a;
    f=a>=0||t>=0;
    a=f?a<0?t:t<0?a:a*P+t*p:0;
    if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
    else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
}